export const CANVAS_VIEWS = {
  MOSAIC: 'mosaic',
  VARIANT: 'variant'
} as const;

